{% block sw_extension_buy_modal %}
<sw-modal
    class="sw-extension-buy-modal"
    :title="$t('sw-extension-store.component.sw-extension-buy-modal.title')"
    size="600px"
    :is-loading="isLoading"
    @modal-close="emitClose"
>

    {% block sw_extension_buy_modal_content %}
        <template v-if="checkoutStep === checkoutSteps.SUCCESS">
            {% block sw_extension_buy_modal_adding_success_content %}
                <sw-extension-adding-success
                    @close="emitClose"
                />
            {% endblock %}
        </template>

        <template v-else-if="checkoutStep === checkoutSteps.FAILED">
            {% block sw_extension_buy_modal_adding_failed_content %}
                <sw-extension-adding-failed
                    :extension-name="extension.name"
                    :title="checkoutError && checkoutError.title"
                    :detail="checkoutError && checkoutError.detail"
                    :documentation-link="checkoutErrorDocumentationLink"
                    @close="emitClose"
                />
            {% endblock %}
        </template>

        <template v-else>
            {% block sw_extension_buy_modal_content_not_installed %}
                {% block sw_extension_buy_modal_variant_selection %}
                    <div class="sw-extension-buy-modal__variants-selection">
                        {% block sw_extension_buy_modal_variant_selection_content %}
                            {% block sw_extension_buy_modal_variant_selection_extension_preview %}
                                <div class="sw-extension-buy-modal__extension-summary">
                                    {% block sw_extension_buy_modal_variant_selection_extension_preview_content %}
                                        {% block sw_extension_buy_modal_variant_selection_extension_icon %}
                                            <sw-extension-icon :src="extension.icon" />
                                        {% endblock %}

                                        {% block sw_extension_buy_modal_variant_selection_extension_name %}
                                            <h4 class="sw-extension-buy-modal__extension-summary-name">
                                                {{ extension.label }}
                                            </h4>
                                        {% endblock %}

                                        {% block sw_extension_buy_modal_variant_selection_extension_trial_phase %}
                                            <p
                                                v-if="isVariantOfTypeRent(selectedVariant) && firstMonthFree"
                                                class="sw-extension-buy-modal__extension-summary-trial-phase"
                                            >
                                                <mt-icon name="regular-check-circle" size="16px" />
                                                {{ $t('sw-extension-store.buy-modal.rent.freeTrial') }}
                                            </p>
                                        {% endblock %}

                                        {% block sw_extension_buy_modal_variant_selection_extension_disclaimer %}
                                            <p
                                                v-if="isVariantOfTypeRent(selectedVariant)"
                                                class="sw-extension-buy-modal__extension-summary-disclaimer"
                                            >
                                                {{ $t('sw-extension-store.buy-modal.rent.disclaimer') }}
                                            </p>
                                        {% endblock %}
                                    {% endblock %}
                                </div>
                            {% endblock %}

                            {% block sw_extension_buy_modal_variant_selection_variant_list %}
                                <ul>
                                    {% block sw_extension_buy_modal_variant_selection_variant_list_item %}
                                        <li
                                            v-for="variant in recommendedVariants"
                                            :key="variant.id"
                                            class="sw-extension-buy-modal__variants-card"
                                            :class="variantCardClass(variant)"
                                            @click="onChangeVariantSelection(variant)"
                                        >

                                            {% block sw_extension_buy_modal_variant_selection_variant_list_item_radio_button %}
                                                <div class="sw-extension-buy-modal__variants-card-input sw-field--radio">
                                                    <div class="sw-field__radio-input">
                                                        <input
                                                            :id="`sw-extension-buy-modal__variant-${variant.type}`"
                                                            type="radio"
                                                            name="variant-selection"
                                                            :value="variant.id"
                                                            :checked="variant.id === selectedVariantId"
                                                            :disabled="isLoading || recommendedVariants.length <= 1"
                                                        >
                                                        <div class="sw-field__radio-state" />
                                                    </div>
                                                </div>
                                            {% endblock %}

                                            {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label %}
                                                {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_description %}
                                                    <label
                                                        :for="`sw-extension-buy-modal__variant-${variant.type}`"
                                                        class="sw-extension-buy-modal__variant-description"
                                                    >
                                                        {{ variant.label || variant.type }}
                                                    </label>
                                                {% endblock %}

                                                {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_rent %}
                                                    <div
                                                        v-if="isVariantOfTypeRent(variant)"
                                                        class="sw-extension-buy-modal__rent"
                                                        :class="getVariantClasses(variant)"
                                                    >

                                                        {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_rent_prices %}
                                                            <div>
                                                                <i18n-t :keypath="getVariantPriceSnippet(variant)" tag="span">
                                                                    <template #price>
                                                                        <strong>{{ getVariantPrice(variant) }}*</strong>
                                                                    </template>
                                                                </i18n-t>
                                                            </div>
                                                        {% endblock %}

                                                        {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_rent_discount_information %}
                                                            <div v-if="hasActiveDiscount(variant)">
                                                                <i18n-t :keypath="getVariantDiscountInformationSnippet(variant)" tag="span">
                                                                    <template #months>
                                                                        {{ variant.discountCampaign.discountAppliesForMonths }}
                                                                    </template>
                                                                    <template #price>
                                                                        {{ renderPrice(variant.netPrice) }}*
                                                                    </template>
                                                                </i18n-t>
                                                            </div>
                                                        {% endblock %}

                                                        {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_rent_additional_information %}
                                                            <div>
                                                                <span v-if="isRentDurationYearly(variant)">
                                                                    <i18n-t keypath="sw-extension-store.general.labelPricePerYear" tag="span">
                                                                        <template #price>
                                                                            {{ renderPrice(variant.netPrice) }}*
                                                                        </template>
                                                                    </i18n-t>
                                                                    -
                                                                </span>
                                                                <span>
                                                                    {{ $t(getVariantCancellationInformationSnippet(variant)) }}
                                                                </span>
                                                            </div>
                                                        {% endblock %}
                                                    </div>

                                                    <div
                                                        v-if="isVariantOfTypeRent(variant) && getVariantBadgeSavings(variant) > 0"
                                                        class="sw-extension-buy-modal__variants-card-badge"
                                                        :class="getVariantBadgeClasses(variant)"
                                                    >
                                                        {{ $t('sw-extension-store.general.labelSavings', { percentage: getVariantBadgeSavings(variant) }) }}
                                                    </div>
                                                {% endblock %}

                                                {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_buy %}
                                                    <div
                                                        v-if="isVariantOfTypeBuy(variant)"
                                                        class="sw-extension-buy-modal__buy"
                                                        :class="getDiscountClasses(variant)"
                                                    >

                                                        {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_buy_prices %}
                                                            <span
                                                                v-if="hasActiveDiscount(variant)"
                                                                class="sw-extension-buy-modal__list-price"
                                                            >
                                                                {{ renderPrice(variant.netPrice) }}
                                                            </span>
                                                            <span class="sw-extension-buy-modal__discounted-price">{{ renderBuyPrice(variant) }}</span>
                                                        {% endblock %}
                                                    </div>
                                                {% endblock %}

                                                {% block sw_extension_buy_modal_variant_selection_variant_list_item_variant_label_fallback %}
                                                    <div
                                                        v-if="!isVariantOfTypeBuy(variant) && !isVariantOfTypeRent(variant)"
                                                        :class="`sw-extension-buy-modal__${variant.type}`"
                                                    >
                                                        <span class="sw-extension-buy-modal__display-default-price">
                                                            {{ renderPrice(variant.netPrice) }}
                                                        </span>
                                                    </div>
                                                {% endblock %}
                                            {% endblock %}
                                        </li>
                                    {% endblock %}
                                </ul>
                            {% endblock %}
                        {% endblock %}
                    </div>
                {% endblock %}

                {% block sw_extension_buy_modal_summary %}
                    <div class="sw-extension-buy-modal__variant-summary">
                        {% block sw_extension_buy_modal_summary_content %}
                            {% block sw_extension_buy_modal_summary_price %}
                                <p class="sw-extension-buy-modal__variant-summary-price">
                                    {% block sw_extension_buy_modal_summary_price_content %}
                                        {% block sw_extension_buy_modal_summary_label_price %}
                                            <span>
                                                {{ $t('sw-extension-store.component.sw-extension-buy-modal.variantSummary.labelPrice') }}
                                            </span>
                                        {% endblock %}

                                        {% block sw_extension_buy_modal_summary_actual_price %}
                                            <span
                                                v-if="!isLoading"
                                                class="sw-extension-buy-modal__variant-summary-actual-price"
                                            >
                                                <i18n-t :keypath="actualPriceSnippet" tag="span">
                                                    <template #price>
                                                        {{ actualPrice }}*
                                                    </template>
                                                </i18n-t>
                                            </span>
                                        {% endblock %}
                                    {% endblock %}
                                </p>

                                <template v-if="isVariantOfTypeRent(selectedVariant) && firstMonthFree">
                                    <i18n-t
                                        v-if="hasActiveDiscount(selectedVariant)"
                                        keypath="sw-extension-store.buy-modal.rent.followingDiscount"
                                        class="sw-extension-buy-modal__variant-summary-price-subline"
                                        tag="p"
                                    >
                                        <template #price>
                                            {{ renderPrice(selectedVariant.discountCampaign.discountedPricePerMonth) }}*
                                        </template>
                                        <template #months>
                                            {{ !isRentDurationMonthly(selectedVariant) ? selectedVariant.duration : selectedVariant.discountCampaign.discountAppliesForMonths }}
                                        </template>
                                    </i18n-t>

                                    <i18n-t
                                        :keypath="finalPriceSnippet"
                                        class="sw-extension-buy-modal__variant-summary-price-subline is--final-price"
                                        tag="p"
                                    >
                                        <template #price>
                                            {{ renderPrice(selectedVariant.netPrice) }}*
                                        </template>
                                    </i18n-t>
                                </template>
                            {% endblock %}

                            {% block sw_extension_buy_modal_summary_renewal_date %}
                                <p
                                    class="sw-extension-buy-modal__variant-summary-price-subline"
                                    :class="renewalDateClasses"
                                >
                                    {{ $t('sw-extension-store.component.sw-extension-buy-modal.variantSummary.renewal', { renewalDate: dateFilter(renewalDate) }, 0) }}
                                </p>
                            {% endblock %}
                        {% endblock %}
                    </div>
                {% endblock %}

                {% block sw_extension_payment_selection %}
                    <sw-single-select
                        v-if="showPaymentSelection"
                        v-model:value="selectedPaymentMean"
                        :options="paymentMeans"
                        :placeholder="$t('sw-extension-store.buy-modal.paymentSelectionPlaceholder')"
                        value-property="id"
                    />
                {% endblock %}

                {% block sw_extension_buy_modal_accept_toc %}
                    <sw-gtc-checkbox
                        v-model:value="tocAccepted"
                        class="sw-extension-buy-modal__checkbox"
                    />
                {% endblock %}

                {% block sw_extension_buy_modal_accept_extension_permissions %}
                    <mt-checkbox
                        v-if="extensionHasPermissions"
                        v-model:checked="permissionsAccepted"
                        class="sw-extension-buy-modal__checkbox sw-extension-buy-modal__checkbox-permissions"
                        :class="`sw-extension-buy-modal__checkbox-permissions--${extension.name}`"
                    >
                        <template #label>
                            <span v-if="legalText">
                                {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.introText') }}
                                <mt-link
                                    class="link permissions-modal-trigger"
                                    as="a"
                                    @click="openPermissionsModal"
                                >
                                    {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.buttonPermissions') }}
                                </mt-link>
                                {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.middleText') }}
                                <mt-link
                                    class="link legal-text-modal-trigger"
                                    as="a"
                                    @click="openLegalTextModal"
                                >
                                    {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.buttonAppProvider') }}
                                </mt-link>
                                {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.endText') }}
                            </span>

                            <span v-else>
                                {{ $t('sw-extension-store.component.sw-extension-buy-modal.labelAcceptPermissions') }}
                                <mt-link
                                    class="link permissions-modal-trigger"
                                    as="a"
                                    @click="openPermissionsModal"
                                >
                                    {{ $t('sw-extension-store.detail.labelButtonShowPermissions') }}
                                </mt-link>
                            </span>
                        </template>
                    </mt-checkbox>
                {% endblock %}

                {% block sw_extension_buy_modal_accept_extension_app_provider %}
                    <mt-checkbox
                        v-if="!extensionHasPermissions && legalText"
                        v-model:checked="legalTextAccepted"
                        class="sw-extension-buy-modal__checkbox sw-extension-buy-modal__checkbox-app-provider"
                        :class="`sw-extension-buy-modal__checkbox-app-provider--${extension.name}`"
                    >
                        <template #label>
                            {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.appProviderStartText') }}
                            <mt-link
                                class="link legal-text-modal-trigger"
                                as="a"
                                @click="openLegalTextModal"
                            >
                                {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.buttonAppProvider') }}
                            </mt-link>
                            {{ $t('sw-extension-store.buy-modal.checkboxes.permissionsAndAppProvider.endText') }}
                        </template>
                    </mt-checkbox>
                {% endblock %}

                {% block sw_extension_buy_modal_accept_extension_privacy_policy_extensions %}
                    <mt-checkbox
                        v-if="extension.privacyPolicyExtension"
                        v-model:checked="privacyExtensionsAccepted"
                        class="sw-extension-buy-modal__checkbox-privacy-policy"
                        :class="`sw-extension-buy-modal__checkbox-privacy-policy--${extension.name}`"
                    >
                        <template #label>
                            <span class="is--required">
                                {{ $t('sw-extension-store.component.sw-extension-buy-modal.labelAcceptPrivacyExtensions') }}
                            </span>
                            <mt-link
                                class="link privacy-policy-modal-trigger"
                                as="a"
                                @click="openPrivacyModal"
                            >
                                {{ $t('sw-extension-store.component.sw-extension-buy-modal.buttonShowPrivacyExtensions') }}
                            </mt-link>
                        </template>
                    </mt-checkbox>
                {% endblock %}

                {% block sw_extension_buy_modal_alert_can_not_buy %}
                    <mt-banner v-if="!userCanBuyFromStore" variant="info">
                        {% block sw_extension_buy_modal_alert_can_not_buy_content %}
                            {{ $t('sw-extension-store.component.sw-extension-buy-modal.alertCanNotBuy.text') }}
                        {% endblock %}
                    </mt-banner>
                {% endblock %}

                {% block sw_extension_buy_modal_alert_payment_means_required %}
                    <mt-banner v-if="showPaymentWarning" variant="attention">
                        {% block sw_extension_buy_modal_alert_payment_means_required_content %}
                            {{ $t('sw-extension-store.buy-modal.warnings.paymentMeansRequiredText') }}
                            <sw-external-link
                                :href="cart && cart.payment && cart.payment.registrationUrl"
                                class="sw-extension-buy-modal__external-link"
                            >
                                {{ $t('sw-extension-store.buy-modal.warnings.paymentMeansRequiredLinkText') }}
                                <mt-icon name="regular-long-arrow-right" />
                            </sw-external-link>
                        {% endblock %}
                    </mt-banner>
                {% endblock %}

                {% block sw_extension_buy_modal_plus_vat %}
                    <p
                        class="sw-extension-buy-modal__plus-vat"
                        :class="vatIncludedClasses"
                    >
                        {{ $t('sw-extension-store.buy-modal.plusVat') }}
                    </p>
                {% endblock %}

                {% block sw_extension_payment_general_text_block %}
                    <p
                        v-if="paymentText"
                        class="sw-extension-buy-modal__general-text-block"
                        v-html="paymentText"
                    />
                {% endblock %}

                {% block sw_extension_buy_modal_button_purchase %}
                    <mt-button
                        class="sw-extension-buy-modal__purchase-button"
                        size="default"
                        variant="primary"
                        block
                        :disabled="!canPurchaseExtension"
                        @click="purchaseExtension"
                    >
                        {{ purchaseButtonLabel }}
                    </mt-button>
                {% endblock %}
            {% endblock %}

            {% block sw_extension_buy_modal_permissions_modal %}
                <sw-extension-permissions-modal
                    v-if="showPermissionsModal"
                    :extension-label="extension.label"
                    :domains="extension.domains"
                    :permissions="extension.permissions"
                    @modal-close="closePermissionsModal"
                />
            {% endblock %}

            {% block sw_extension_buy_modal_privacy_extensions_modal %}
                <sw-extension-privacy-policy-extensions-modal
                    v-if="showPrivacyModal"
                    :extension-name="extension.label"
                    :privacy-policy-extension="extension.privacyPolicyExtension"
                    @modal-close="closePrivacyModal"
                />
            {% endblock %}

            {% block sw_extension_buy_modal_legal_text_modal %}
                <sw-modal
                    v-if="showLegalTextModal"
                    class="sw-extension-buy-modal__legal-text-modal"
                    :title="$t('sw-extension-store.buy-modal.legalTextModal.title')"
                    @modal-close="closeLegalTextModal"
                >
                    <div v-html="legalText" />

                    <template #modal-footer>
                        <mt-button
                            variant="primary"
                            size="small"
                            @click="closeLegalTextModal"
                        >
                            {{ $t('global.default.close') }}
                        </mt-button>
                    </template>
                </sw-modal>
            {% endblock %}
        </template>
    {% endblock %}
</sw-modal>
{% endblock %}
